import { render, staticRenderFns } from "./AddProviderModal.vue?vue&type=template&id=3ce63484&"
import script from "./AddProviderModal.vue?vue&type=script&lang=js&"
export * from "./AddProviderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports